/**
 * React component for pause menu overlay.
 * Displays when game is paused with options to resume, open settings, or return to main menu.
 */

import { useGameStateStore } from '@shared/stores';
import { isDevSettingsAvailable } from '@shared/stores/devSettingsStore';

export default function PauseMenu() {
  const {
    isPaused,
    resumeGame,
    returnToMenu,
    showInGameSettingsMenu,
    showInGameSettings,
    showDevSettingsMenu,
  } = useGameStateStore();

  // Don't show pause menu if in-game settings are open
  if (!isPaused || showInGameSettings) {
    return null;
  }

  const handleSettings = () => {
    // Show in-game settings overlay (keeps game paused in background)
    showInGameSettingsMenu();
  };

  return (
    <div className="absolute inset-0 z-50 bg-black bg-opacity-75 flex items-center justify-center">
      <div className="bg-gray-800 rounded-lg p-8 flex flex-col gap-4 min-w-[300px]">
        <h2 className="text-2xl font-bold text-white mb-4 text-center">Game Paused</h2>
        <button
          onClick={resumeGame}
          className="px-6 py-3 bg-green-700 hover:bg-green-600 text-white rounded transition-colors font-semibold"
        >
          Resume
        </button>
        <button
          onClick={handleSettings}
          className="px-6 py-3 bg-blue-700 hover:bg-blue-600 text-white rounded transition-colors font-semibold"
        >
          Settings
        </button>
        {isDevSettingsAvailable() && (
          <button
            onClick={showDevSettingsMenu}
            className="px-6 py-3 bg-purple-700 hover:bg-purple-600 text-white rounded transition-colors font-semibold"
          >
            Dev Settings
          </button>
        )}
        <button
          onClick={returnToMenu}
          className="px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white rounded transition-colors font-semibold"
        >
          Return to Main Menu
        </button>
      </div>
    </div>
  );
}
